export enum ProvisionEnvironment {
    Dev = 0,
    Test = 1,
    Prod = 2
}